<div class="centered-dialog dark:bg-gray-900">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="w-1/5 flex items-center flex-col">
        @if (!isChristmas && !isEaster && !isSummer && !isHalloween && !isCarnival && !isAshWednesday && !isStarWars && !isFootball && !isMaintenance) {
            <div class="relative h-[176px] w-[220px] mr-11 bg-[url('/assets/img/applogo.svg')] bg-no-repeat bg-center"></div>
        }
        @if (isChristmas && !isMaintenance) {
            <div class="relative h-[176px] w-[220px] mr-11 bg-[url('/assets/img/applogoChristmas.svg')] bg-no-repeat bg-center"></div>
        }
        @if (isEaster && !isMaintenance) {
            <div class="relative h-[176px] w-[220px] mr-11 bg-[url('/assets/img/applogoEaster.svg')] bg-no-repeat bg-center"></div>
        }
        @if (isSummer && !isFootball && !isMaintenance) {
            <div class="relative h-[176px] w-[220px] mr-11 bg-[url('/assets/img/applogoSummer.svg')] bg-no-repeat bg-center"></div>
        }
        @if (isHalloween && !isMaintenance) {
            <div class="relative h-[176px] w-[220px] mr-11 bg-[url('/assets/img/applogoHalloween.svg')] bg-no-repeat bg-center"></div>
        }
        @if (isCarnival && !isMaintenance) {
            <div class="relative h-[176px] w-[220px] mr-11 bg-[url('/assets/img/applogoCarnival.svg')] bg-no-repeat bg-center"></div>
        }
        @if (isAshWednesday && !isMaintenance) {
            <div class="relative h-[176px] w-[220px] mr-11 bg-[url('/assets/img/applogoAshWednesday.svg')] bg-no-repeat bg-center"></div>
        }
        @if (isStarWars && !isMaintenance) {
            <div class="relative h-[176px] w-[220px] mr-11 bg-[url('/assets/img/applogoStarWars.svg')] bg-no-repeat bg-center"></div>
        }
        @if (isFootball && !isMaintenance) {
            <div class="relative h-[176px] w-[220px] mr-11 bg-[url('/assets/img/applogoFootball.svg')] bg-no-repeat bg-center"></div>
        }
        @if (isMaintenance) {
            <div class="relative h-[176px] w-[220px] mr-11 bg-[url('/assets/img/applogoMaintenance.svg')] bg-no-repeat bg-center"></div>
        }
        @if (showLogout) {
            <blockquote>
                {{ 'LOGOUT.GOODBYEMESSAGE' | translate }}
            </blockquote>
        }
        <section>
            <div class="rounded my-4 p-2 bg-red-100 dark:bg-red-300 flex-grow border-solid border-red border flex text-red mobileHint:hidden text-xs">
                {{ 'LOGIN.HINT.DIMENSION' | translate }}
            </div>
            <bsm-input
                controlName="accountName"
                [label]="'LOGIN.USERNAMEEMAIL' | translate"
                [error]="'LOGIN.ERROR.ACCOUNT_REQUIRED' | translate"
                elementId="username"
                inputName="username"
                autocomplete="username"
                autocapitalize="none"
                autocorrect="off"
                spellcheck="false"
                [showErrorOnlyOnTouched]="true">
            </bsm-input>
            <bsm-input
                controlName="password"
                [label]="'LOGIN.PASSWORD' | translate"
                [error]="'LOGIN.ERROR.PASSWORD_REQUIRED' | translate"
                type="password"
                elementId="password"
                inputName="current-password"
                autocomplete="current-password"
                autocapitalize="none"
                autocorrect="off"
                spellcheck="false"
                [showErrorOnlyOnTouched]="true">
            </bsm-input>
            @if (errorMessage) {
                <je-message-box type="error" class="block mb-4">
                    {{ errorMessage | translate }}
                </je-message-box>
            }
            <je-button type="submit" variant="primary" [label]="'LOGIN.SUBMIT' | translate" [centered]="true" [block]="true" iconRight="chevron-right" class="mb-4"> </je-button>
            <je-button
                variant="neutral"
                [label]="'LOGIN.FORGOT_PASSWORD' | translate"
                [routerLink]="['/password', 'request-reset', loginForm.value.accountName]"
                [centered]="true"
                [block]="true">
            </je-button>
            <div class="bg-gray-100 rounded mb-4 p-2 flex-grow border-solid border-black-100 text-black-500 dark:bg-gray-800 dark:text-gray-300 border mt-4 text-xs">
                {{ 'LOGIN.HINT.BROWSER' | translate }}
            </div>
        </section>
    </form>
</div>
<div class="absolute bottom-0 right-0 z-10000 bg-gray-200 text-black-500 rounded m-2 p-2 text-xs dark:bg-gray-800 dark:text-gray-300">
    <je-version></je-version>
</div>
